import { getCache as r, KnownDomain as o } from "@ado/client-side-caching";
import { reactive as n, readonly as s } from "vue";
const t = n({
  availableContracts: []
}), C = () => s(t), m = (e, a) => {
  t.availableContracts = a, i(e);
}, v = () => {
  t.availableContracts = [];
}, b = (e) => {
  const a = r().getItem(c(e));
  a !== void 0 && (t.availableContracts = a);
}, i = (e) => {
  r().setItem(c(e), t.availableContracts);
}, c = (e) => r().createKey(o.Foundation, "search", e);
export {
  C as getSearch,
  v as resetSearch,
  b as restoreSearchFromCache,
  m as setSearch
};
//# sourceMappingURL=index2.js.map
